// 오픈런 미리보기 url로 들어오더라도, 오픈 상태면 기획전 상세로 리다이렉트
import { getApiBaseUrl } from '~/utils'

export default async function ({ route, redirect, $axios }) {
  if (route.query?.prirNtcnYn !== 'Y') {
    return
  }

  const exbtNo = route.query?.exbtNo
  if (!exbtNo) {
    return
  }

  try {
    const body = await $axios.$post(getApiBaseUrl() + '/ds/exbt/selPrirExbt', {
      exbtThmeNm: '',
      exbtListExprYn: 'Y'
    })

    const rows = Array.isArray(body?.data) ? body.data : []
    const row = rows.find(r => String(r.exbtNo) === String(exbtNo))

    const isOpen = row?.prirOpenYn === '0'
    if (isOpen) {
      const { prirNtcnYn, ...restQuery } = route.query

      return redirect({ path: '/ds/spexhbt/C211', query: restQuery })
    }
  } catch (e) {
    // 조회 실패 시에는 오픈런 미리보기 url 유지
  }
}
